// import axios from 'axios';
//
// const SetupAxios = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     timeout: 30000,
// });
//
// SetupAxios.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('_token');
//         if (token) {
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );
//
// SetupAxios.interceptors.request.use(
//     (request) => {
//         console.log('Starting Request:', request.url);
//         return request;
//     }
// );
//
// SetupAxios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.code === 'ECONNABORTED') {
//             console.error('Timeout: The server took too long to answer.');
//             // Option: Notifier l'utilisateur ou relancer la requête
//         } else if (error.response?.status === 401) {
//             console.error('Unauthorized: redirection to login');
//             window.location.href = '/login';
//         }
//         return Promise.reject(error);
//     }
// );
//
// export default SetupAxios;



import axios from 'axios';

const AUTH_STORAGE_KEYS = ['_token', '_userInterface', '_clientCreationDate'] as const;

const clearAuthStorage = () => {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

const SetupAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
});

// Add request interceptor to set Authorization header before each request
SetupAxios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

SetupAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            clearAuthStorage();
        }

        return Promise.reject(error);
    }
);

axios.interceptors.request.use(request => {
    // console.log('*** Starting Request ***')
    return request
})

export default SetupAxios;
